const ROLES = {
  GET_ALL: 'roles/getAllRoles',
  GET_ALL_SUCCESS: 'roles/getAllRoles/fulfilled',
  GET: 'roles/getRoles',
  GET_SUCCESS: 'roles/getRoles/fulfilled',
  CREATE: 'role/create',
  CREATE_SUCCESS: 'role/create/fulfilled',
  UPDATE: 'role/update',
  UPDATE_SUCCESS: 'role/update/fulfilled',
  REMOVE: 'role/remove',
  REMOVE_SUCCESS: 'role/remove/fulfilled',
}

const USERS = {
  GET_ALL: 'users/getAllUsers',
  GET_ALL_SUCCESS: 'users/getAllUsers/fulfilled',
  GET: 'users/getUsers',
  GET_SUCCESS: 'users/getUsers/fulfilled',
  GET_PROFILE: 'users/getProfile',
  GET_PROFILE_SUCCESS: 'users/getProfile/fulfilled',
  CREATE: 'users/create',
  CREATE_SUCCESS: 'users/create/fulfilled',
  UPDATE: 'users/update',
  UPDATE_SUCCESS: 'users/update/fulfilled',
  UPDATE_PROFILE: 'users/updateProfile',
  UPDATE_PROFILE_SUCCESS: 'users/updateProfile/fulfilled',
  REMOVE: 'users/remove',
  REMOVE_SUCCESS: 'users/remove/fulfilled',
}

const FUELSTATIONS = {
  GET_ALL: 'fuelStations/getAllFuelStations',
  GET_ALL_OWN: 'fuelStations/ownStations/getAllFuelStationsOwn',
  REMOVE_OWN: 'fuelStations/ownStations/remove',
}

const CENTERS = {
  GET_ALL: 'centers/getAllCenters',
  CREATE: 'centers/create',
  UPDATE: 'centers/update',
  REMOVE: 'centers/remove',
}

const COMPANIES = {
  GET_ALL: 'companies/getAllCompanies',
  CREATE: 'companies/create',
  UPDATE: 'companies/update',
  REMOVE: 'companies/remove',
}

export { ROLES, USERS, FUELSTATIONS, CENTERS, COMPANIES }
